var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['select-field', {'select-field--error': _vm.error}]},[_c('v-select',{class:{'select-error': _vm.error},attrs:{"value":_vm.value,"items":_vm.items,"input-value":"value","label":_vm.placeholder,"drop-down-image":"/v2/common/arrow-down.svg"},on:{"change":_vm.onUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }